import React from "react";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import crown from "./assets/crown.png";   // adjust path
import bg from "./assets/back.png"; // adjust path

const Subscription = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50">
      <div className="relative bg-white rounded-2xl shadow-xl w-[90%] max-w-sm overflow-hidden">
        {/* Background */}
        <img
          src="https://cdn.acsdev.in/Rentastic/back.png"
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Close button */}
        <button
          type="button"
          onClick={onClose}  // ✅ uses parent onClose
          className="absolute top-3 right-3 bg-black/70 hover:bg-black text-white 
                     rounded-full p-2 shadow-lg z-50 transition"
        >
          <X size={22} />
        </button>

        {/* Content */}
        <div className="relative flex flex-col items-center p-8 z-10 text-center">
          {/* Crown */}
          <div className="bg-black/40 p-10 rounded-full shadow-lg mb-6">
            <img src="https://cdn.acsdev.in/Rentastic/crown.png" alt="Crown" className="w-30 h-30" />
          </div>

          {/* Text */}
          <p className="text-white text-lg font-medium mb-6">
            Become our premium member <br /> to access unlimited offers
          </p>

          {/* Subscribe Button */}
          <button
            onClick={() => navigate("/ThankyouCart")}  
            className="bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg hover:bg-green-600 transition"
          >
            Subscribe Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
